import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'
import messages from '@/langs'
import { Validator } from 'vee-validate'

Vue.use(VueI18n)

locale.i18n((key, value) => i18n.t(key, value))

const DEFAULT_LANGUAGE = 'en'
const loadedLanguages = [DEFAULT_LANGUAGE] // our default language that is prelaoded
const supportedLanguages = [DEFAULT_LANGUAGE, 'zh']

export const localesMap = {
  zh: 'zh-TW',
  en: 'en'
}

function setI18nLanguage (lang) {
  i18n.locale = lang
  Validator.localize(lang)
  document.querySelector('html').setAttribute('lang', lang)
  return lang
}

export function getSupportedLanguage (language) {
  return [
    language,
    window.localStorage.getItem('lang'),
    ...(window.navigator.languages || [window.navigator.language]),
    DEFAULT_LANGUAGE
  ]
    .filter(Boolean)
    .map(x => x.slice(0, 2))
    .filter(x => supportedLanguages.includes(x))
    .find(Boolean)
}

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: DEFAULT_LANGUAGE,
  messages
})

export function loadLanguageAsync (lang) {
  lang = getSupportedLanguage(lang)

  window.localStorage.setItem('lang', lang)

  if (i18n.locale !== lang) {
    if (!loadedLanguages.includes(lang)) {
      return import(/* webpackChunkName: "lang-[request]" */ `../langs/${lang}`)
        .then(msgs => {
          i18n.setLocaleMessage(lang, msgs.default)
          loadedLanguages.push(lang)
          return setI18nLanguage(lang)
        })
    }
    return Promise.resolve(setI18nLanguage(lang))
  }
  return Promise.resolve(lang)
}



// WEBPACK FOOTER //
// ./src/i18n/index.js